export default __webpack_public_path__ + "assets/greece-flag.png";